import { render, staticRenderFns } from "./measurements.vue?vue&type=template&id=6fb09658&"
import script from "./measurements.vue?vue&type=script&lang=js&"
export * from "./measurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports